import { GetClientModel } from "@factory/model/query-model-client";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { clientFormDefault } from "./form.default";
import { ClientFormSchema } from "./form.rule";

export const useFormDefaultClient = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetClientModel | undefined) => {
    return !cachedValue
      ? clientFormDefault
     : ({
        name: cachedValue.name,
        email: cachedValue.email,
        address: cachedValue.address,
        city: cachedValue.city,
        province: cachedValue.province,
        contactNumber: cachedValue.contact_number,
      } as ClientFormSchema);
  };

  return {
    getDefault,
  };
};
